import { render, staticRenderFns } from "./ApplicantPersonalDocuments.vue?vue&type=template&id=30c12786&"
import script from "./ApplicantPersonalDocuments.vue?vue&type=script&lang=js&"
export * from "./ApplicantPersonalDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantPersonalDocuments.vue?vue&type=style&index=0&id=30c12786&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports